import {get} from "lodash";
import {getBoolean, getInteger, getString} from "Core/helpers/data";
import {SORT_ORDER} from "Core/const/global";
import {pagination_default_per_page} from "Config/app";

/**
 * Unique Redux store key associated with this reducer.
 * IMPORTANT: All reducers must export this value!
 * @type {string}
 */
export const reducerStoreKey = 'eFaxLogDialog';

// Define reducer types handled by these reducers
export const REDUCER_TYPES = {
	RESET: '@eFaxLogDialog/reset',
	SET_LIST_DATA: '@eFaxLogDialog/set_list_data',
	CLEAR_LIST_DATA: '@eFaxLogDialog/clear_list_data',
};

// Define action creators for all reducer types
export const actionCreators = {
	reset: () => ({type: REDUCER_TYPES.RESET}),
	/**
	 * @param {IoJsonFetchResponseObject} eFaxLogListData
	 * @return {{type: string, listData: IoJsonFetchResponseObject}}
	 */
	setEFaxLogListData: eFaxLogListData => ({
		type: REDUCER_TYPES.SET_LIST_DATA,
		listData: eFaxLogListData
	}),
	clearEFaxLogListData: () => ({type: REDUCER_TYPES.CLEAR_LIST_DATA}),
};

/**
 * Initial reducer state
 * IMPORTANT: All reducers must export an initial state object!
 * @type {Object<string, any>}
 */
export const initialState = {
	/** @type {IoJsonFetchResponseObject} */
	listData: null,
};

// Reducer function
const reducer = (state = {...initialState}, action) => {
	switch (action.type) {
		case REDUCER_TYPES.RESET: return { ...initialState };

		case REDUCER_TYPES.SET_LIST_DATA: return {...state, listData: action.listData};
		case REDUCER_TYPES.CLEAR_LIST_DATA: return {...state, listData: initialState.listData};

		default: return state;
	}
};

// Selectors
export const selectors = {
	getEFaxLogList: state => get(state, [reducerStoreKey, 'listData', 'data']),
	getEFaxLogListPagination: state => ({
		perPage: getInteger(state, [reducerStoreKey, 'listData', 'perPage'], pagination_default_per_page),
		pageNo: getInteger(state, [reducerStoreKey, 'listData', 'pageNo'], 1),
		totalRows: getInteger(state, [reducerStoreKey, 'listData', 'totalResults']),
		isLastPage: getBoolean(state, [reducerStoreKey, 'listData', 'isLastPage'])
	}),
	getEFaxLogListSort: state => ({
		sortBy: getString(state, [reducerStoreKey, 'listData', 'sortBy'],'creationDate'),
		sortDir: getString(state, [reducerStoreKey, 'listData', 'sortDir'], SORT_ORDER.DESC)
	}),
	getEFaxLogListFilter: state => get(state, [reducerStoreKey, 'listData', 'filter'], null),
};

export default reducer;